<template>
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.16669 5.83333V4.16667C3.16669 3.72464 3.34228 3.30072 3.65484 2.98816C3.9674 2.67559 4.39133 2.5 4.83335 2.5H6.50002M14.8334 2.5H16.5C16.942 2.5 17.366 2.67559 17.6785 2.98816C17.9911 3.30072 18.1667 3.72464 18.1667 4.16667V5.83333M18.1667 14.1667V15.8333C18.1667 16.2754 17.9911 16.6993 17.6785 17.0118C17.366 17.3244 16.942 17.5 16.5 17.5H14.8334M6.50002 17.5H4.83335C4.39133 17.5 3.9674 17.3244 3.65484 17.0118C3.34228 16.6993 3.16669 16.2754 3.16669 15.8333V14.1667" stroke="#30485E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "AreaIcon"
}
</script>
